module.exports = __webpack_public_path__ + "static/media/loopback.89564caa.png";